'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import React from 'react';


var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _zoomable = require('./zoomable');

var _zoomable2 = _interopRequireDefault(_zoomable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgWrapper = function () {
  function SvgWrapper(props) {
    _classCallCheck(this, SvgWrapper);

    this.setSvg = this.setSvg.bind(this);
  }

  _createClass(SvgWrapper, [{
    key: 'setSvg',
    value: function setSvg(props) {
      this.svg = (0, _zoomable2.default)(props);
    }
  }, {
    key: 'create',
    value: function create(input) {
      this.setSvg(input);
    }
  }, {
    key: 'update',
    value: function update(input) {
      this.destroy(input.el);
      this.setSvg(input);
      this.draw(input);
    }
  }, {
    key: 'destroy',
    value: function destroy(el) {
      d3.select(el).selectAll('svg').remove();
    }
  }, {
    key: 'draw',
    value: function draw(props) {
      var _this = this;

      var svg = props.svg,
          svgPath = props.svgPath;

      if (svg && svg.includes('<svg')) {
        this.renderStr(props, svg);
      } else {
        var path = svg || svgPath;
        d3.xml(path).then(function (file) {
          return _this.renderFile(props, file);
        }).catch(function (err) {
          return console.log(err);
        }); // eslint-disable-line
      }
    }
  }, {
    key: 'renderFile',
    value: function renderFile(props, file) {
      var resize = props.resize;

      var node = file.getElementsByTagName('svg')[0];
      if (node) {
        if (resize) {
          node.setAttribute('width', '100%');
          node.setAttribute('height', '100%');
        }

        this.svg.node().innerHTML = '';
        this.svg.node().appendChild(node);
      }
    }
  }, {
    key: 'renderStr',
    value: function renderStr(props, str) {
      var dom = new DOMParser().parseFromString(str, 'image/svg+xml');
      var resize = props.resize;

      var node = dom.getElementsByTagName('svg')[0];
      if (node) {
        if (resize) {
          node.setAttribute('width', '100%');
          node.setAttribute('height', '100%');
        }

        this.svg.node().innerHTML = '';
        this.svg.node().appendChild(node);
      }
    }
  }]);

  return SvgWrapper;
}();

exports.default = SvgWrapper;